
"use client";

import { title } from "@/components/primitives";
import { openDB, deleteDB, wrap, unwrap } from "idb"
import React, { useEffect, useState} from "react"


export default function SportGym() {

  return (
    <div>
      <h1 className={title()}>Tělocvična</h1>
    </div>
  );
}
